/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pumps_Permutation_TextInputs */

const fr_pumps_permutation_text = /** @type {((inputs: Pumps_Permutation_TextInputs) => LocalizedString) & { parts: (inputs: Pumps_Permutation_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Pumps_Permutation_TextInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Lorsque la permutation des chaudières est en auto, la permutation des pompes doubles
s’effectue au même moment (Voir la permutation des pompes)`)
		}),
		{
			parts: /** @type {(inputs: Pumps_Permutation_TextInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Lorsque la permutation des chaudières est en auto, la permutation des pompes doubles\ns’effectue au même moment (" }, { type: "markup-start", name: "dialog", options: {}, attributes: {} }, { type: "text", value: "Voir la permutation des pompes" }, { type: "markup-end", name: "dialog", options: {}, attributes: {} }, { type: "text", value: ")" }])
			})
		}
	)
);

const en_pumps_permutation_text = /** @type {((inputs: Pumps_Permutation_TextInputs) => LocalizedString) & { parts: (inputs: Pumps_Permutation_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Pumps_Permutation_TextInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`When the boiler permutation is set to auto, the double pumps permutation
happens at the same time (See pumps permutation)`)
		}),
		{
			parts: /** @type {(inputs: Pumps_Permutation_TextInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "When the boiler permutation is set to auto, the double pumps permutation\nhappens at the same time (" }, { type: "markup-start", name: "dialog", options: {}, attributes: {} }, { type: "text", value: "See pumps permutation" }, { type: "markup-end", name: "dialog", options: {}, attributes: {} }, { type: "text", value: ")" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "When the boiler permutation is set to auto, the double pumps permutation happens at the same time (See pumps permutation)" |
*
* @param {Pumps_Permutation_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const pumps_permutation_text = /** @type {((inputs?: Pumps_Permutation_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs?: Pumps_Permutation_TextInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Pumps_Permutation_TextInputs, { locale?: "fr" | "en" }, { dialog: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Pumps_Permutation_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_pumps_permutation_text(inputs)
			return fr_pumps_permutation_text(inputs)
		}),
		{
			parts: /** @type {(inputs?: Pumps_Permutation_TextInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Pumps_Permutation_TextInputs) => import('../runtime.js').MessagePart[] }} */ (en_pumps_permutation_text).parts?.(inputs) ?? [{ type: "text", value: en_pumps_permutation_text(inputs) }]
				return /** @type {{ parts?: (inputs: Pumps_Permutation_TextInputs) => import('../runtime.js').MessagePart[] }} */ (fr_pumps_permutation_text).parts?.(inputs) ?? [{ type: "text", value: fr_pumps_permutation_text(inputs) }]
			})
		}
	)
);